<template>
	<div v-if="errors.length > 1" >
		<ul v-if="show" class="label-help">
			<li v-for="(error, index) in errors" :key="index">{{ error }}</li>
		</ul>
	</div>
	<div v-else-if="errors.length === 1">
		<div v-if="show" class="label-help">{{ errors[0] }}</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'InputErrorDisplay',
	props: {
		show: {
			type: Boolean,
			required: true
		},
		errors: {
			type: Array,
			default: null
		}
	}
});
</script>
